<script lang="ts">
	import Dialog from "#lib/Dialog.svelte";

	type Props = {
		open: boolean;
		formId?: string | null;
		formUrl?: string | null;
	};

	let { open = $bindable(false), formId, formUrl }: Props = $props();
</script>

<Dialog bind:open class="py-8">
	{#if open}
		{#await import("#lib/HubspotFormEmbed.svelte") then Module}
			<Module.default {formId} {formUrl} />
		{/await}
	{/if}
</Dialog>
